import styled, { keyframes } from "styled-components";
import { fadeIn } from "react-animations";

import bubble1 from "./img/bubble-1@2x.png";
import bubble2 from "./img/bubble-2@2x.png";
import bubble3 from "./img/bubble-3@2x.png";
const fadeInAnimation = keyframes`${fadeIn}`;
const bubble1Animation = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(calc(6rem/100));
  }
`;
const bubble2Animation = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(calc(8rem/100));
  }
`;
const bubble3Animation = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(calc(9rem/100));
  }
`;

export const BrandWrapper = styled.div`
  width: calc(281rem/100);
  height: calc(181rem/100);
  background: rgba(255, 255, 255, 1);
  border-radius: calc(4rem/100);
  position: relative;
  margin: 0 auto;
`;

export const BrandLogo = styled.img`
  position: absolute;
  width: calc(128rem/100);
  height: calc(40rem/100);
  bottom: calc(21rem/100);
  left: 50%;
  transform: translateX(-50%);
  animation: .8s ${fadeInAnimation} ease-in-out 0.8s 1 both;
`;

const Bubble = styled.div`
  position: absolute;
  background: transparent none center no-repeat;
  background-size: contain;
  animation: 0.8s none ease-in 0s infinite alternate;
`;

export const Bubble1 = styled(Bubble)`
  width: calc(81rem/100);
  height: calc(37rem/100);
  top: calc(25rem/100);
  left: calc(22rem/100);
  background-image: url(${bubble1});
  animation-name: ${bubble1Animation};
`;

export const Bubble2 = styled(Bubble)`
  width: calc(90rem/100);
  height: calc(41rem/100);
  top: calc(65rem/100);
  left: calc(77rem/100);
  background-image: url(${bubble2});
  animation-name: ${bubble2Animation};
  animation-delay: 0.8s;
`;

export const Bubble3 = styled(Bubble)`
  width: calc(98rem/100);
  height: calc(45rem/100);
  top: calc(25rem/100);
  right: calc(21rem/100);
  background-image: url(${bubble3});
  animation-name: ${bubble3Animation};
  animation-delay: 0.4s;
  animation-direction: 0.6s;
`;
